import styled from 'styled-components';

export const DashboardsTab = styled.ul`
	font-size: 11px;
	margin-top: 49px;
	font-weight: 700;

	li a {
		padding: 14px;
		cursor: pointer;
	}

	.nav-item a {
		color: #6c757d;

		i {
			padding-right: 5px;
			font-size: 14px;
		}
	}

	.nav-item a:hover {
		border: none;
		border-bottom: 1px solid #46389e;
	}

	.nav-item .active {
		color: #5341c6;
		border: none;
		border-bottom: 1px solid #46389e;
		background-color: rgba(104, 96, 228, 0.04);
	}
`;
